import React from 'react';
import styled from '@emotion/styled';
import Markdown from 'react-markdown';

import colors from '../../styling/colors';
import track from '../../hocs/tracking';

const Container = styled.div`
  color: ${colors('boulder')};
  font-size: 0.675rem;
  line-height: 1.125rem;
  margin: 0 auto 5rem;
  max-width: 100%;
  padding: 0 1.5rem;
`;

/* Markdown styles */
const Paragraph = styled.p`
  margin: 0 0 1rem;
`;
const TrackedLink = track(styled.a``, {
  identifier: 'seo_footer_read_more',
  trackAs: 'element',
});
const StyledLink = styled(TrackedLink)`
  background: none;
  border: none;
  color: ${colors('gatsby')};
  margin: 0;
  padding: 0;
`;

const markdownConfig = {
  allowedTypes: ['text', 'paragraph', 'link'],
  renderers: {
    link: props => <StyledLink {...props} />,
    paragraph: props => <Paragraph {...props} />,
  },
};

function SeoFooter({ content, className }) {
  if (!content || content.length === 0) {
    return null;
  }

  return (
    <Container className={className}>
      <Markdown {...markdownConfig} source={content} />
    </Container>
  );
}

export const LandingPageSeoFooter = styled(SeoFooter)`
  margin: 5rem auto;
`;

export default SeoFooter;
